<template>
  <button class="pushable" data-external="fancy-button" :disabled="disabled" @click="onClick">
    <span class="shadow"></span>
    <span class="edge"></span>
    <span class="front">
      <UCIcon v-if="loading" icon="fa-spinner-third" spin />
      <slot v-else />
    </span>
  </button>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'FancyButton',
  components: {
    UCIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    return {
      onClick: () => emit('click'),
    };
  },
});
</script>

<style lang="scss" scoped>
.pushable {
  position: relative;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  outline-offset: 4px;
  transition: filter 250ms;
  width: 100%;

  &:hover:not(:disabled) {
    filter: brightness(105%);

    .front {
      transform: translateY(-6px);
      transition: transform 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
    }

    .shadow {
      transform: translateY(4px);
      transition: transform 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
    }
  }

  &:active:not(:disabled) {
    .front {
      transform: translateY(-2px);
      transition: transform 34ms;
    }

    .shadow {
      transform: translateY(1px);
      transition: transform 34ms;
    }
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
  }
}
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: hsl(0deg 0% 0% / 0.25);
  will-change: transform;
  transform: translateY(2px);
  transition: transform 600ms cubic-bezier(0.3, 0.7, 0.4, 1);
  border-radius: 1px;
}
.edge {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--c-primary-800);
  border-radius: 1px;
}
.front {
  display: block;
  position: relative;
  padding: 12px 42px;
  font-size: 18px;
  font-weight: 700;
  color: white;
  background: var(--c-primary-500);
  will-change: transform;
  transform: translateY(-4px);
  transition: transform 600ms cubic-bezier(0.3, 0.7, 0.4, 1);
  border-radius: 1px;
}
</style>
